"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var fiftyFiftyBannerLocal = function fiftyFiftyBannerLocal(theme) {
  return {
    appearance: {
      primary: {
        iconAppearance: 'primary',
        primaryButtonAppearance: 'primary',
        secondaryButtonAppearance: 'secondary',
        inverseButton: false,
        inverseIcon: false,
        inverseText: false,
        backgroundColor: theme.color.monochrome1["default"]
      },
      secondary: {
        iconAppearance: 'primary',
        primaryButtonAppearance: 'secondary',
        secondaryButtonAppearance: 'alt1',
        inverseButton: true,
        inverseIcon: true,
        inverseText: true,
        backgroundColor: theme.color.monochrome5["default"]
      },
      alt1: {
        iconAppearance: 'primary',
        primaryButtonAppearance: 'secondary',
        secondaryButtonAppearance: 'alt1',
        inverseButton: false,
        inverseIcon: false,
        inverseText: false,
        backgroundColor: theme.color.monochrome2["default"]
      }
    },
    height: {
      sm: 300,
      md: 432,
      lg: 432
    }
  };
};
var _default = fiftyFiftyBannerLocal;
exports["default"] = _default;